<template>
  <div>
    <modal :show.sync="editModal" header-classes="bg-primary p-3" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        ADD IMAGE
      </h6>
      <AddPageDetail />
      <template slot="footer">
        <base-button type="primary">SUBMIT</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <!-- addproductdetails -->
    <modal
      :show.sync="ShowProductDetails"
      header-classes="bg-primary p-3"
      size="lg"
    >
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        ADD PRODUCT DETAILS
      </h6>
      <AddProductDetails />
      <template slot="footer">
        <base-button type="primary">SUBMIT</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="ShowProductDetails = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <b-card class="rounded-2xl mb-4 cust-shadow cardbody-p">
      <div class="row">
        <div class="col-sm-3">
          <img :src="item.img" class="rounded-lg" :alt="item.title" />
        </div>

        <div class="col-sm-6 py-2 pl-2">
          <div>
            <p class="font-bold">{{ item.title }}</p>
            <small class="text-muted">{{ item.description }}</small>
          </div>
          <div class="color mt-4">
            <p class="font-semibold text-md rounded-full">Color</p>
            <div class="flex mt-2">
              <div
                v-for="(item, index) in 4"
                :key="'item-' + index"
                class="p-2px rounded-full mr-1"
                @click="handleClick(item)"
                :class="{ 'active-color': selectedItem === item }"
              >
                <p
                  class="color-dot w-4 h-4 rounded-full"
                  :style="{ background: color[item - 1] }"
                ></p>
              </div>
            </div>
          </div>

          <div class="size mt-6">
            <p class="font-semibold text-md rounded-full">Select Size</p>
            <div class="flex mt-4 justify-between items-center">
              <div class="flex">
                <div
                  class="
                    border
                    cursor-pointer
                    rounded-full
                    text-center
                    border-primary-hover
                    mr-3
                    py-2
                    w-20
                    0
                  "
                  v-for="(item, index) in sizeOptions"
                  :key="'item-' + index"
                  @click="handleSize(item)"
                  :class="{ 'border-primary': item === selectedSize }"
                >
                  <p
                    class="font-semibold text-xs"
                    :class="{ 'text-primary': item === selectedSize }"
                  >
                    {{ item.size }}<br />
                    <small
                      class="fsize11"
                      :class="{ 'text-primary': item === selectedSize }"
                      >Rs. {{ item.price }}</small
                    >
                  </p>
                </div>
              </div>

              <div class="">
                <h2 class="font-bold text-lg">Rs.{{ ShowPrice }}</h2>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-3 flex items-center">
          <div class="pr-4">
            <base-button
              outline
              type="light"
              @click="editModal = true"
              class="mb-2 w-full py-2 text-sm"
            >
              Add Images
            </base-button>
            <base-button
              type="success"
              @click="ShowProductDetails = true"
              class="mb-2 w-full py-2 text-sm"
            >
              Add Product Details
            </base-button>
            <base-button type="danger" outline class="mb-2 w-full py-2 text-sm">
              Delete
            </base-button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import AddPageDetail from "./AddPageDetail";
import AddProductDetails from "./AddProductDetails";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    AddPageDetail,
    AddProductDetails,
  },
  data() {
    return {
      color: ["#172b4d", "#5e72e4", "#2dce89", "#f5365c"],
      sizeOptions: [
        {
          size: "S",
          price: "2759",
        },
        {
          size: "M",
          price: "2500",
        },
        {
          size: "L",
          price: "2259",
        },
      ],
      selectedItem: 1,
      selectedSize: null,
      editModal: false,
      ShowProductDetails: false,
    };
  },
  computed: {
    ShowPrice() {
      return this.selectedSize && this.selectedSize.price;
    },
  },
  methods: {
    handleClick(item) {
      this.selectedItem = item;
    },
    handleSize(item) {
      this.selectedSize = item;
    },
  },
};
</script>

<style scoped>
.active-color {
  border: 1px solid black;
}
</style>
